import { select, Selection } from "d3-selection";
import { BarChartSvgChartArea } from "./bar-chart-svg-chart-area";
import { ChartMargin } from "../interfaces/chart-margin";

export class BarChartSvg {
    selection: Selection<SVGElement, unknown, HTMLElement, any>;
    chartArea: BarChartSvgChartArea;
    constructor(id, parentWidth, parentHeight) {
        this.selection = select(`#${id}`)
            .append("svg")
            .attr("width", parentWidth)
            .attr("height", parentHeight);
    }

    public show() {
        this.selection.style("visibility", "inherit");
        return this;
    }

    public hide() {
        this.selection.style("visibility", "hidden");
        return this;
    }

    public appendInBarLabelBackgroundFilter() {
        const filter = this.selection
            .append("defs")
            .append("filter")
            .attr("x", "-0.1")
            .attr("y", "-0.1")
            .attr("width", "1.2")
            .attr("height", "1.2")
            .attr("id", "uic-bar-chart__in-bar-label-background");
        filter
            .append("feFlood")
            .attr("flood-color", "white")
            .attr("flood-opacity", "0.4");
        filter
            .append("feComposite")
            .attr("in", "SourceGraphic")
            .attr("operator", "xor"); // avoid blurry text, only show cut-out

        return filter;
    }

    public appendYAxisLabelArea() {
        return this.selection
            .append("g")
            .attr("class", "uic-bar-chart__y-axis-label");
    }

    public appendChartArea(margin: ChartMargin): BarChartSvgChartArea {
        this.chartArea = new BarChartSvgChartArea(this.selection, margin);
        return this.chartArea;
    }

    public updateDimensions(
        parentWidth: number,
        parentHeight: number,
        transitionDurationMs: number
    ) {
        this.selection
            .transition()
            .duration(transitionDurationMs)
            .attr("width", parentWidth)
            .attr("height", parentHeight);

        return this;
    }

    public updateYAxisLabel(
        yAxisLabelData: string[],
        margin: ChartMargin,
        parentHeight: number,
        transitionDurationMs: number
    ) {
        const yAxisLabel = this.selection
            .select(".uic-bar-chart__y-axis-label")
            .selectAll("text")
            .data(yAxisLabelData);
        yAxisLabel
            .enter()
            .append("text")
            .attr("text-anchor", "middle")
            .attr("y", margin.left)
            .attr("x", -parentHeight / 2)
            .attr("transform", "rotate(-90)")
            .attr("dy", "1em")
            .text((d) => d);

        yAxisLabel
            .text((d) => d)
            .transition()
            .duration(transitionDurationMs)
            .attr("y", margin.left)
            .attr("x", -parentHeight / 2);

        yAxisLabel.exit().remove();

        return this;
    }
}
